import React, { useState, useEffect, useRef } from "react"
import { useReactToPrint } from "react-to-print"
import { Col, Form, Row, Modal, Button } from "react-bootstrap"
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin"
import {
  getZReading,
} from "../../Helpers/apiCalls/reportsAPI"
import {
  formatDateNoTime,
  getRole,
  numberWithCommas,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common"
import toast from "react-hot-toast"

import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import "jspdf-autotable"
import { useNavigate } from "react-router-dom"
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI"

function ZReading() {
  const navigate = useNavigate()
  const role = getRole()
  const [inactive, setInactive] = useState(true)
  const [exportTo, setExportTo] = useState("")
  const [allData, setAllData] = useState({})
  const [otherDiscounts, setOtherDiscounts] = useState([])
  const [mainDetails, setMainDetails] = useState({})
  const [cashLedgerData, setCashLedgerData] = useState([])
  const [creditLedgerData, setCreditLedgerData] = useState([])
  const [showPrompt, setShowPrompt] = useState(false);
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  })

  async function fetchReportView(type) {
    const response = await getZReading(type, filter.date_from, filter.date_to)
    if (response.data) {
      setAllData(response.data.data)
      setMainDetails(response.data.data.reports)
      setOtherDiscounts(response.data.data.reports.other_discount)
      setCashLedgerData(
        response.data.data.cash_ledger.cash_ledgers === null
          ? []
          : response.data.data.cash_ledger.cash_ledgers
      )
      setCreditLedgerData(response.data.data.credit_ledger.credit_ledgers)
    }else {
      const errorMsg =
        response.error?.data?.messages?.error ?? "Something went wrong";
      setAllData({});
      setMainDetails({});
      setOtherDiscounts([]);
      setCashLedgerData([]);
      setCreditLedgerData([]);
      // promptError(errorMsg);
      setShowPrompt(true)
    }
  }

  async function fetchReport(type) {
    setAllowPrint(true)
    const response = await getZReading(type, filter.date_from, filter.date_to)
    if (response.data) {
      setExportTo(type)
      setAllData(response.data.data)
      setMainDetails(response.data.data.reports)
      setCashLedgerData(
        response.data.data.cash_ledger.cash_ledgers === null
          ? []
          : response.data.data.cash_ledger.cash_ledgers
      )
      setCreditLedgerData(response.data.data.credit_ledger.credit_ledgers)
      // handlePrint()
      handleAutoPrint()
    }
  }
  //handle for date filter
  const handleFilter = (e) => {
    const { name, value } = e.target
    var filtercopy = { ...filter }
    filtercopy[name] = value
    setFilter(filtercopy)
  }

  // Initialized variable for ref print category
  const print = useRef()
  const componentExportPDF = useRef()
  // Handle for print category using useReactToPrint
  const handlePrint = useReactToPrint({
    content: () => print.current,
    pageStyle: "@page { size: letter; margin: 5mm; }",
  })

  const handleExportPDF = (e) => {
      // const pdf = new jsPDF();
      // const content = componentExportPDF.current;
      // html2canvas(content).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png");
      //   const imgWidth = 200; // Set the width of the image (A4 size)
      //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
      //   const x = (pdf.internal.pageSize.width - imgWidth) / 2;
      //   pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
      //   pdf.save("Category Sales Report.pdf");
      // });

      const pdf = new jsPDF();
      const content = componentExportPDF.current;

      html2canvas(content).then((canvas) => {
        const imgWidth = 200; 
        // const pageHeight = pdf.internal.pageSize.height; 
        const pageHeight = 280; 
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Scaled height of the image
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        let heightLeft = canvasHeight;
        let position = 0;

        while (heightLeft > 0) {
          const canvasSection = document.createElement("canvas");
          canvasSection.width = canvasWidth;
          canvasSection.height = Math.min(heightLeft, (pageHeight * canvasWidth) / imgWidth);

          const ctx = canvasSection.getContext("2d");
          ctx.drawImage(canvas, 0, position, canvasWidth, canvasSection.height, 0, 0, canvasWidth, canvasSection.height);

          const sectionData = canvasSection.toDataURL("image/png");
          const x = (pdf.internal.pageSize.width - imgWidth) / 2;

          pdf.addImage(sectionData, "PNG", x, 10, imgWidth, (canvasSection.height * imgWidth) / canvasWidth);

          heightLeft -= canvasSection.height;
          position += canvasSection.height;

          if (heightLeft > 0) {
            pdf.addPage();
          }
        }

        pdf.save("Financial Report.pdf")
      });   
  };

  

  const divId = useRef(null) // Initialize useRef with null
  const [allowPrint, setAllowPrint] = useState(false)

  const handleAutoPrint = () => {
    // setIsClicked(true)
    if (divId.current) {
      const element = divId.current

      // Apply custom CSS for the desired paper size (80mm x 297mm)
      // element.style.width = "40%"
      element.style.width = "var(--receipt-width)";
      // element.style.height = "100%"

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png")
        printBase64Data(imgData)
        toast.success("Processing...", {
          style: toastStyle(),
        })
      })
    }
  }

  async function printBase64Data(image) {
    const response = await printBase64(window.printer_name, image, "0")
    if (response.data) {
      setAllowPrint(false)
      setAllowPrint(false)
      refreshPage()
    } else {
      // setIsClicked(false)
    }
  }

  // API CALLS REACT USE EFFECT
  // useEffect(() => {
  //   fetchReportView("print")
  // }, [allowPrint])
  useEffect(() => {
    fetchReportView("print")
  }, [filter])
  return (
    <div>
      {(getRole() === "1" || getRole() === "7") && (
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Category Report"}
          page={"Category Report"}
        />
      )}
      <div
        className={`container ps-5 pt-4 bold-font ${
          role === "2" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col>
            <h1>
              {getRole() === "1" || getRole() === "7"
                ? "Z READING REPORT"
                : "DAILY SALES REPORT"}
            </h1>
          </Col>
          <Col className="d-flex justify-content-end mb-2">
            {getRole() === "1" || getRole() === "7" ? (
              <button
                className="category-new-export-btn"
                value={"zcounter"}
                onClick={(e) => fetchReport(e.target.value)}
              >
                PRINT
              </button>
            ) : (
              <button
                className="category-new-export-btn"
                value={"print"}
                onClick={(e) => fetchReport(e.target.value)}
              >
                PRINT
              </button>
            )}
            &nbsp;&nbsp;
            <button
              className="category-new-export-btn"
              value="pdf"
              onClick={(e) => handleExportPDF(e.target.value)}
            >
              EXPORT TO PDF
            </button>
            &nbsp;&nbsp;
            {getRole() !== "1" && (
              <button
                className="category-new-export-btn"
                value="pdf"
                onClick={() => navigate(-1)}
              >
                BACK
              </button>
            )}
          </Col>
          <hr />
        </Row>
        {(getRole() === "1" || getRole() === "7") && (
          <div className="my-2 px-4 PO-filters d-flex">
            <span className="me-1 align-middle mt-2">FILTER</span>
            <span className="me-1 align-middle mt-2">BY</span>
            <span className="me-3 align-middle mt-2">DATE:</span>
            <span className="me-4 align-middle mt-2"> FROM:</span>
            <Form.Control
              size="sm"
              type="date"
              name="date_from"
              className="date-filter me-3"
              onChange={handleFilter}
              value={filter.date_from}
            />
            {/* <span className="me-4 align-middle mt-2">TO:</span>
            <Form.Control
              size="sm"
              type="date"
              name="date_to"
              className="date-filter me-3"
              onChange={handleFilter}
              value={filter.date_to}
            /> */}
          </div>
        )}
        {/* {role === "1" && (
          <Row className="pt-3">
            <Col className="cat-container">
              <label>Filter by Date From:</label>
              <input
                type="date"
                name="date_from"
                id="date_from"
                className="responsive-date-input"
                defaultValue={filter.date_to}
                onChange={handleFilter}
              ></input>
            </Col>
            <Col className="cat-container">
              <label>Date To:</label>
              <input
                type="date"
                name="date_to"
                id="date_to"
                className="responsive-date-input"
                defaultValue={filter.date_from}
                onChange={handleFilter}
              ></input>
            </Col>
            <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
          </Row>
        )} */}
        <div
          // className={`redo-x-z-reading-cont ${
          //   role === "2" ? "cashier" : "admin"
          // }`}
          className="redo-x-z-reading-cont p-5"
        >
          <Row
            ref={
              exportTo === "print" || allowPrint ? divId : componentExportPDF
            }
          >
            <Col>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address1}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address2}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <strong>
                    {role === "1" || role === "7" ? "Z Reading" : "Daily Sales Report"}
                  </strong>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>{formatDateNoTime(new Date(filter.date_from))}</label>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="print-text">
                  {/* <label>Current Sales</label> */}
                  <label>Gross Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.gross_sales ? mainDetails.gross_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Sales Net of Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.net_sales ? mainDetails.net_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.tax_sales ? mainDetails.tax_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Vat Exempt Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.vat_exempt_sales
                        ? mainDetails.vat_exempt_sales
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Zero-Rated</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.zero_rated ? mainDetails.zero_rated : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>No. Transactions</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.no_of_transactions
                        ? mainDetails.no_of_transactions
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Quantity</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_qty ? mainDetails.total_qty : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Subtotal Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.subtotal_discount
                        ? mainDetails.subtotal_discount
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              {/* <Row>
                <Col className="print-text">
                  <label>Total VAT Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_vat_exempt
                        ? mainDetails.total_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row> */}
              <Row>
                <Col className="print-text">
                  <label>No. of Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.no_of_cancelled_si
                        ? mainDetails.no_of_cancelled_si
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Amount Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.amount_cancelled
                        ? mainDetails.amount_cancelled
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>S. Citizen Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.s_citizen_disc
                        ? mainDetails.s_citizen_disc
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col xl={8} className="print-text">
                  <label>No. Senior Citizen Discount</label>
                </Col>
                <Col xl={4} className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.no_s_citizen_disc
                        ? mainDetails.no_s_citizen_disc
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>S. Citizen Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.s_citizen_vat_exempt
                        ? mainDetails.s_citizen_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>PWD Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.pwd_disc ? mainDetails.pwd_disc : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>No. PWD Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.no_pwd_disc ? mainDetails.no_pwd_disc : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>PWD Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.pwd_vat_exempt
                        ? mainDetails.pwd_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              {otherDiscounts.map((data) => (
                <>
                  <Row>
                    <Col xl={8} className=" print-text">
                      <Row>
                        <label>{data.name.toUpperCase()} Disc</label>
                        <label>No. {data.name.toUpperCase()} Disc</label>
                      </Row>
                    </Col>
                    <Col
                      xl={4}
                      className="d-flex justify-content-end text-right print-text"
                    >
                      <Row>
                        <label>
                          {parseFloat(
                            data.total_discount > 0 ? data.total_discount : 0.0
                          ).toFixed(2)}
                        </label>

                        <label>
                          {data.no_of_discount ? data.no_of_discount : 0}
                        </label>
                      </Row>
                    </Col>
                  </Row>
                </>
              ))}
              <Row>
                <Col className="print-text">
                  <label>OPEN ITEM VAT EXEMPT</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.open_item_vat_exempt
                        ? mainDetails.open_item_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Vat</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.expanded_value_added_tax
                        ? mainDetails.expanded_value_added_tax
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>No. Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.no_expanded_value_added_tax
                        ? mainDetails.no_expanded_value_added_tax
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Card Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_card ? mainDetails.total_card : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Foodpanda Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_foodpanda
                        ? mainDetails.total_foodpanda
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Grab Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_grab ? mainDetails.total_grab : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Gcash Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_gcash ? mainDetails.total_gcash : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Maya Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_maya ? mainDetails.total_maya : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Qr PH Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.total_qrph ? mainDetails.total_qrph : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <label>Cash Ledger</label>
                {cashLedgerData?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text">
                        <label>{data.cashier}</label>
                      </Col>
                      <Col className="d-flex justify-content-end print-text">
                        <label>
                          {numberWithCommas(
                            parseFloat(data.total_cash).toFixed(2)
                          )}
                        </label>
                      </Col>
                    </Row>
                  )
                })}
              </Row>
              <Row>
                <label>Credit Ledger</label>
                {creditLedgerData?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text">
                        <label>{data.cashier}</label>
                      </Col>
                      <Col className="d-flex justify-content-end print-text">
                        <label>
                          {numberWithCommas(
                            parseFloat(data.total_credit).toFixed(2)
                          )}
                        </label>
                      </Col>
                    </Row>
                  )
                })}
              </Row>
              <Row className="print-text">
                <label>Media Summary</label>
                <Col></Col>
                <Col className="d-flex justify-content-left print-text">
                  <label>
                    Cash :{" "}
                    {allData.media_summary
                      ? numberWithCommas(
                          parseFloat(
                            allData.media_summary.media_summary.cash
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
                <Col className="d-flex justify-content-left print-text">
                  <label>
                    Credit :{" "}
                    {allData.media_summary
                      ? numberWithCommas(
                          parseFloat(
                            allData.media_summary.media_summary.credit
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
                {/* <Col className="d-flex justify-content-left">
                  <label>
                    GC :{" "}
                    {allData.media_summary
                      ? allData.media_summary.media_summary.gc
                      : "0.00"}
                  </label>
                </Col> */}
                <Col></Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Beg. SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>{allData.beg_si}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>End SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>{allData.end_si}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Prev. Total</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.prev_grand_accumulated_total
                        ? mainDetails.prev_grand_accumulated_total
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Current Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      mainDetails.gross_sales ? mainDetails.gross_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              {/* <Row>
                <Col className="print-text bold-text">
                  <label>Running Totals:</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                </Col>
              </Row>*/
              <Row>
                <Col className="print-text">
                  <label>New Grand Total</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.new_total ? mainDetails.new_total : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              /*<Row>
                <Col className="print-text">
                  <label>Sales Net of Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_sales_net_of_discount ? mainDetails.running_sales_net_of_discount : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_vat_sales ? mainDetails.running_vat_sales : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>VAT Exempt Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_vat_exempt_sales ? mainDetails.running_vat_exempt_sales : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>SC/PWD Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_total_discount ? mainDetails.running_total_discount : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>VAT Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_vat_exemp ? mainDetails.running_vat_exemp : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total VAT</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {numberWithCommas(
                      parseFloat(
                        mainDetails.running_total_vat ? mainDetails.running_total_vat : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row> */}
              <hr />
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text smaller-text">
                  <label>{window.myt_address1}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_address2}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label> {window.myt_acc_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_issued_date}</label>
                </Col>
              </Row>
              {/* <Row>
                <Col className="d-flex justify-content-center print-text">
                  <label>VALID UNTIL : 00/00/00</label>
                </Col>
              </Row> */}
            </Col>
          </Row>
          <Modal
            size="lg"
            show={showPrompt}
            onHide={() => setShowPrompt(false)}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Body className="bold-font">
              <Row>
                <Row>
                  <Col className="text-center mt-5 prompt-error">
                    PLEASE GENERATE PREVIOUS BILLING
                  </Col>
                </Row>
                <Col>
                  <Row style={{ textAlignLast: "center" }} className="mt-5">
                    <Col sm={8}></Col>
                    <Col sm={4} className="align-right">
                      <Button
                        size="lg"
                        className="save-btn"
                        style={{
                          width: "70%",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                        }}
                        onClick={() => setShowPrompt(false)}
                      >
                        OK
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default ZReading
